import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import locationPng from '../../assets/location.png';
import bedPng from '../../assets/bed.png';
import scalePng from '../../assets/scale.png';
import bathtubPng from '../../assets/bathtub.png';
import { slugify } from '../../utils/slugify';

const Content = ({ data }) => {
  const [index, setIndex] = useState(0);
  const [buyRealEstate, setBuyRealEstate] = useState([]);
  const [sortOrder, setSortOrder] = useState('latest'); // State for sort order
  const propertiesPerPage = 9;
  const navigate = useNavigate();

  useEffect(() => {
    setBuyRealEstate(data.filter((property) => property.status === 'approved'));
  }, [data]);

  const totalPages = Math.ceil(buyRealEstate.length / propertiesPerPage);

  const handleClick = (property) => {
    navigate(`/property/${slugify(property.name)}`);
  };

  const handleSort = (order) => {
    let sortedProperties = [...buyRealEstate];

    switch (order) {
      case 'latest':
        sortedProperties.sort(
          (a, b) => new Date(b.createdAt) - new Date(a.createdAt)
        );
        break;
      case 'max-price':
        sortedProperties.sort(
          (a, b) => parseFloat(b.price) - parseFloat(a.price)
        );
        break;
      case 'min-price':
        sortedProperties.sort(
          (a, b) => parseFloat(a.price) - parseFloat(b.price)
        );
        break;
      default:
        break;
    }

    setBuyRealEstate(sortedProperties);
    setSortOrder(order); // Update sort order
  };

  const renderProperties = (startIndex) => {
    return buyRealEstate
      .slice(startIndex, startIndex + propertiesPerPage)
      .map((property, key) => (
        <div
          key={key}
          className="px-2 pb-2 md:px-8 md:pb-8 w-[90vw]  md:w-[45vw] lg:w-[30vw]"
          onClick={() => handleClick(property)}
        >
          <div className="border border-[#E9E9E9]-400  rounded shadow-md p-1">
            <div className="relative overflow-hidden">
              <img
                src={property.images[0]}
                alt="dubaiPhoto"
                className="h-[40vh] object-cover w-[100%] rounded-sm duration-300 hover:scale-[1.2]"
              />
            </div>
            <div className="flex flex-col px-[3%]">

              <div className="flex justify-between items-center">
                <div className="text-left font-semibold text-lg pt-4 text-black">
                  {property?.name ? property.name.replace(/[-\d]/g, " ") : ""}
                </div>
                <div className="pt-4 font-semibold text-black lg:text-md">
                  {property.price > 0 ? property.price + " AED" : "Contact Us"}
                </div>
              </div>

              <div className="flex  py-2">
                <div className="flex flex-col">
                  <div className="text-base md:text-lg text-left font-semibold flex justify-center items-center">
                    <div>{property.bedrooms}</div>
                    <img
                      src={bedPng}
                      alt="bed"
                      className="md:w-8 md:h-8 w-4 h-4 mx-2"
                    />
                  </div>
                  {/* <div className="text-[10px] md:text-sm text-gray-400">
                    Beds
                  </div> */}
                </div>
                <div className="flex flex-col mx-4">
                  <div className="text-base md:text-lg text-left font-semibold flex justify-center items-center">
                    <div>{property.bathrooms}</div>
                    <img
                      src={bathtubPng}
                      alt="bed"
                      className="md:w-8 md:h-8 w-4 h-4 mx-2"
                    />
                  </div>
                  {/* <div className="text-[10px] md:text-sm text-gray-400">
                    Bathrooms
                  </div> */}
                </div>
                <div className="flex flex-col">
                  <div className="text-base md:text-lg text-left font-semibold flex justify-center items-center">
                    <div>{property.square}</div>
                    <img
                      src={scalePng}
                      alt="bed"
                      className="md:w-8 md:h-8 w-4 h-4 mx-2"
                    />
                  </div>
                  {/* <div className="text-[10px] md:text-sm text-gray-400">
                    Square(ft)
                  </div> */}
                </div>
              </div>

              <div className="text-left py-1 text-sm text-gray-400 flex items-center">
                <img src={locationPng} alt="location" className="w-4 m-1" />
                <div>{property.location}</div>
              </div>
            </div>
          </div>
        </div>
      ));
  };

  return (
    <div className="relative *:font-sans">
      <div className="my-5 font-semibold text-left ml-[7%] text-3xl">
        Buying Real Estate
      </div>
      <div className="my-5 ml-[7%] flex items-center">
        <select
          value={sortOrder}
          onChange={(e) => handleSort(e.target.value)}
          className="px-4 py-2 bg-white border rounded"
        >
          <option value="latest">Latest</option>
          <option value="max-price">By Maximum Price</option>
          <option value="min-price">By Minimum Price</option>
        </select>
      </div>
      <div className="flex flex-col justify-center flex-wrap items-center md:flex-row">
        {renderProperties(index * propertiesPerPage)}
      </div>
      <div className="relative mb-12 mx-auto flex justify-center sm:my-[2%]">
        {Array.from({ length: totalPages }, (_, i) => (
          <div
            key={i}
            onClick={() => setIndex(i)}
            className={`mx-2 px-6 py-5 border border-black duration-300 cursor-pointer ${index === i
                ? 'bg-black text-white'
                : 'hover:bg-black hover:text-white'
              }`}
          >
            {i + 1}
          </div>
        ))}
      </div>
    </div>
  );
};

export default Content;
